import React from 'react';
import { Segment, Form, Input, Button, Icon, Dropdown, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { validateCityZip } from '../../util/helpers'

/**
 * New address component
 */
export default class NewAddress extends React.Component {

	actualHco;
	actualAddress;
	actualPostalCode;

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
			addressDisabled: true,
			hcoDisabled: true,
			postalCodeDisabled: true,
			hcos: [],
			validationError: null
        }
	}

	handleCityChange = (e, { name, value }) => {
		this.setState((prevState) => ({ ...prevState, city: value, addressDisabled: false }))

		// Get address list by city
		this.props.fetchAddress(value);
		
		// Validate city-zip combination
		const postalCode = document.getElementById('postalCode').value;
		if (postalCode && value && this.props.cityZipData) {
			const validation = validateCityZip(value, postalCode, this.props.cityZipData);
			this.setState({ validationError: validation.valid ? null : validation.message });
		}
	}

	handleAddressChange = (e, { name, value }) => {
		this.actualAddress = value;
		this.actualHco = ''; // HINT we will populate this field later, while exporting

		// Get all distinct HCOs from the address list by value
		const hcos = [...new Set(this.props.address.filter(a => a.value === value).map(a => a.hco))];

		this.setState((prevState) => ({ ...prevState, hcos, hcoDisabled: false }))
	}

	handlePostalCodeChange = (e, { name, value }) => {
		this.setState((prevState) => ({ ...prevState, postalCodeDisabled: false }))
		this.actualPostalCode = value;
		
		// Validate city-zip combination
		if (this.state.city && value && this.props.cityZipData) {
			const validation = validateCityZip(this.state.city, value, this.props.cityZipData);
			this.setState({ validationError: validation.valid ? null : validation.message });
		}
	}

	handleHcoChange = (e, { name, value }) => {
		this.actualHco = value;
	}

	/**
	 * Init
	 */
	componentDidMount() {
		this.props.clearRequestUi();
		if (this.props.cities.length === 0)
		{
			this.props.fetchCities();
			this.props.fetchCitiesWithPostalCode();
		}
	}

	componentWillUnmount() {
		this.props.clearRequestUi();
	}
	
	/**
	 * Save new address
	 */
	handleRequestAddNewAddress() {
		var visitorTerritory = this.props.visitorTerritory;
		var license = this.props.match.params.license;
		var city = this.state.city;
		var postalCode = document.getElementById('postalCode').value;
		var address = this.actualAddress;
		var hco = this.actualHco;

		if (city === undefined || postalCode === undefined || address === undefined)
		{
			alert('Minden adat megadása kötelező. Rendszerben már szereplő cím újra nem vihető fel.');
		}
		else
		{
			if (postalCode.length !== 4 || isNaN(postalCode))
			{
				alert('Irányítószámnak négy számból kell állnia.');
			}
			else
			{
				// Validate city-zip combination
				const validation = validateCityZip(city, postalCode, this.props.cityZipData);
				if (!validation.valid) {
					alert('Irányítószám és település nem egyezik!\n\n' + validation.message);
					return;
				}
				
				this.props.requestAddNewAddress(visitorTerritory, license, city, postalCode, address, hco);
			}
		}
	}

	render() {
		return  <Segment basic loading={ this.props.isLoading || this.props.isSaving }>
                    { this.props.error === undefined ? '' : <Message error>Hiba történt. { this.props.error }</Message> }
					{ this.state.validationError ? <Message error><Icon name='warning sign' />{this.state.validationError}</Message> : '' }
					<h3>Új cím</h3>
					<Message info>Biztosan új címet szeretnél felvenni? Már rákerestél, hogy nem létező cím ez a rendszerben? Kattints a <Link to={ '/addAddress/' + this.props.match.params.license }>Vissza</Link> gombra, ha még nem kerestél rá.</Message>
					<Form>
						<Form.Field required>
							<label>Irányítószám</label>
							<Input  style={{ width: '20%' }} placeholder="0000" id='postalCode' onChange={ this.handlePostalCodeChange }/>
						</Form.Field>						
						<Form.Field required>
							<label>Település</label>
							<Dropdown
								placeholder='Először adj meg irányítószámot, majd kezd el beírni a település nevét'
								id='city'
								fluid
								search
								disabled={ this.state.postalCodeDisabled }
								onChange={ this.handleCityChange }
								selection
								options={ this.props.cities }
							/>
						</Form.Field>					
						<Form.Field required>
							<label>Utca, házszám</label>
							<Dropdown
								disabled={this.state.addressDisabled}
								placeholder='Kezd el beírni a cím nevét'
								id='address'
								fluid
								search
								onChange={ this.handleAddressChange }
								selection
								options={ Array.from(new Set(this.props.address.map(addr => addr.value))).map((value, index) => ({ key: index, value: value, text: value })) }
							/>
						</Form.Field>
						<Form.Field>
							<label>Intézmény</label>
							<Dropdown
								disabled={this.state.hcoDisabled}
								placeholder='Válassz intézményt'
								id='hco'
								fluid
								search
								onChange={ this.handleHcoChange }
								selection
								options={ this.state.hcos.map(hco => ({ key: hco, value: hco, text: hco })) }
							/>
						</Form.Field>
						<Link to={ '/addAddress/' + this.props.match.params.license }><Button basic primary>Vissza</Button></Link>
						<Button floated='right' onClick={ () => this.handleRequestAddNewAddress() } primary><Icon name='check' /> Mentés</Button>
					</Form>
				</Segment>
	}
}